import { Fragment, useEffect, useState } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import config from "../config"

function Container(props) {
	return <div className={'container mx-auto px-8 lg:px-10 '+props.className}>{props.children}</div>
}

function MainHeading(props) {
	return <h1 className={'font-lido text-3xl mt-6 mb-10 '+props.className}>{props.children}</h1>
}

function SubHeading(props) {
	return <h1 className={'font-lido text-2xl mt-6 mb-10 '+props.className}>{props.children}</h1>
}

function DocumentSection(props) {
	return <div className={(props.cardStyle ? 'p-8 bg-gray-100 rounded mb-5 print:p-0 print:bg-white ' : 'mb-5 ')+(props.className || '')}>
		{
			props.title && <div className={'font-lido text-xl mb-4'}>{props.title}</div>
		}
		{props.children}
	</div>
}

function LinkList(props) {
	return <div className={'flex gap-4 flex-wrap '+(props.blockLinks ? 'flex-col ' : '')+props.className}>{props.children}</div>
}

function Text(props) {
	const navigate = useNavigate();

	return <p className={'font-lido text-lg text-container '+props.className} 
		dangerouslySetInnerHTML={props.text ? {__html: props.text} : null}
		onClick={(event) => {
			try {
				if (event.target.tagName.toLowerCase() == 'a' && (!event.target.getAttribute('href').toLowerCase().startsWith('https://') && !(event.target.getAttribute('href').startsWith('http://')))) {
					event.preventDefault();
					navigate(event.target.getAttribute('href'));
				}
			}
			catch(e) {}
		}}
	>{props.children}</p>
}

function HtmlContent(props) {
	const navigate = useNavigate();

	return <div className={props.className} dangerouslySetInnerHTML={{__html: props.html}} 
		onClick={(event) => {
			try {
				if (event.target.tagName.toLowerCase() == 'a' && (!event.target.getAttribute('href').toLowerCase().startsWith('https://') && !(event.target.getAttribute('href').startsWith('http://')))) {
					event.preventDefault();
					navigate(event.target.getAttribute('href'));
				}
			}
			catch(e) {}
		}} />
}

function Table(props) {
	const getColumnValue = (item, column) => {
		let val;

		try {
			if (column.indexOf('.') > -1) {
				val = props.columns[column].labelFunction ? props.columns[column].labelFunction(item) : (
					item[column.split('.')[0]][column.split('.')[1]]
				);
			}
			else {
				val = props.columns[column].labelFunction ? props.columns[column].labelFunction(item) : (
					item[column]
				);
			}
		}
		catch (e) {
			val = ''
		}

		return props.columns[column].formatter ? props.columns[column].formatter(val, item) : val;
	}

	return <table className="w-full border-b-[1px]">
		<thead>
			<tr>
				{
					Object.keys(props.columns).map((item, index) => <th key={index} width={props.columns[item] && props.columns[item].columnWidth ? props.columns[item].columnWidth : null} className="text-left py-2 border-b-[1px]">{props.columns[item].heading}</th>)
				}
			</tr>
		</thead>
		<tbody className="divide-y">
			{
				props.rows.map((item, index) => <tr key={index}>
					{
						Object.keys(props.columns).map((col, colIndex) => <td className={'py-2 '+(props.columns[col].className ? props.columns[col].className : '')}>
							{
								props.columns[col].linkElementFunc && !props.columns[col].link && props.columns[col].linkElementFunc(item)
							}
							{
								props.columns[col].link && !props.columns[col].linkElementFunc && <Link to={props.columns[col].link.linkPrefix+item[props.columns[col].link.linkField]}>
									{getColumnValue(item, col)}
								</Link>
							}
							{!props.columns[col].link && !props.columns[col].linkElementFunc && getColumnValue(item, col)}
						</td>)
					}
				</tr>)
			}
		</tbody>
	</table>
}

function FilterHelp(props) {
	return <div className="absolute block right-0 top-0 group">
		<div className="bg-gray-100 rounded-full w-[30px] h-[30px] border border-gray-300 shadow-md rounded font-bold text-sam_theme text-center pt-[3px]">?</div>
		<div className="absolute min-w-[300px] top-0 left-0 p-4 bg-white border border-gray-300 shadow-md rounded-sm z-[1000] pointer-events-none opacity-0 transition-all group-hover:pointer-events-auto group-hover:opacity-100">
			{props.helpText}
			{
				props.helpLink && <div className="pt-4"><Link to={props.helpLink}>{window.l('See more')}</Link></div>
			}
		</div>
	</div>
}

function DocumentThumbnailList(props) {
	return <div className={(props.listMode && props.listMode == 'list' ? 'grid grid-cols-1 ' : 'grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-4 ')+props.className}>{props.children}</div>
}

function DocumentThumbnailLink(props) {
	const location = useLocation();

	return <Link to={'/archive/'+props.data.id+'/myndir'+location.search} className={'group p-5 bg-gray-100/40 flex flex-col items-center rounded-md shadow-sm hover:shadow-md hover:bg-gray-100 '+props.className}>
		<img src={'//fornbref.arnastofnun.is'+props.data.thumbnail} className="group-hover:scale-105 transition" />
		<div className="mt-5">{props.data.shelfmark}</div>
	</Link>
}

function DocumentListItem(props) {
	const navigate = useNavigate();
	const location = useLocation();

	const formatDescription = (s) => {
		if (!s) {
			return '';
		}

		const splitByQuotes = (str) => {
			return str.match(/"([^"]+)"|\S+/g).map(word => word.replace(/"/g, ''));
		};

		if (props.searchString) {
			//let searchWords = props.searchParams.q.split(' ');
			let searchWords = splitByQuotes(props.searchString);
			let ret = s;

			searchWords.forEach(item => {
				if (item.trim() !== "") {
					let escapedItem = item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
					
					let regex = new RegExp(`(${escapedItem})`, 'gi');
					
					ret = ret.replace(regex, '<span class="s-hl">$1</span>');
				}
			});

			return ret;
		}
		else {
			return s;
		}
	}

	return <Link to={'/archive/'+props.data.key+'/lysing'+location.search} className={'group p-5 bg-gray-100/40 rounded-md shadow-sm hover:shadow-md hover:bg-gray-100 border-b items-center '+props.className}>
		<div className="flex gap-5">
			<div className="link flex-grow"><span className="text-sam_red font-bold">{props.data.shelfmark}</span><span className="ml-6 inline-block italic text-gray-600">&nbsp;{props.data.date_act ? props.data.date_act : props.data.date_written ? props.data.date_written : ''}</span></div>
			<div className="w-[30px] flex justify-center relative">
				<img src={'//fornbref.arnastofnun.is'+props.data.thumbnail} className="group-hover:scale-[2] transition max-w-[30px] max-h-[30px]" onClick={(event) => {
					event.preventDefault();

					navigate('/archive/'+props.data.id+'/myndir'+location.search)
				}} />
			</div>
		</div>

		<div className="mr-10 overflow-hidden text-nowrap group-hover:text-wrap group-hover:overflow-auto text-ellipsis">
			<div dangerouslySetInnerHTML={{__html: formatDescription(props.data.items.length > 0 ? props.data.items[0].item : '')}} />
		</div>

	</Link>
}

function LoadingBar(props) {
	return <div className={'loading-bar transition-all'+(props.loading ? ' loading' : '')}>
		<div className="indicator" />
	</div>	
}

function ItemList(props) {
	return <div className="rounded-md divide-y divide-x-1 divide-gray-200">{props.children}</div>
}

function ListItem(props) {
	const className = props.className+' link p-5 bg-gray-100/40 flex gap-5 shadow-sm hover:shadow-md hover:bg-gray-100';

	return props.link ? <Link to={props.link} className={className}>{props.children}</Link> : <div className={className}>{props.children}</div>;
}

function ForeignLabel(props) {
	const [label, setLabel] = useState('');

	useEffect(() => {
		if (!label && props.idValue) {
			fetch(config.apiRoot+props.apiEndpoint+'/'+props.idValue)
				.then(res => res.json())
				.then(json => setLabel(json[props.labelEndpointField]))
		}
	}, [props.idValue]);

	return <Fragment>
		{props.labelFunc ? props.labelFunc(label) : label}{props.children}
	</Fragment>
}

function RangeInput(props) {
	const [inputValue, setInputValue] = useState('');

	useEffect(() => {
		setInputValue(typeof props.value === 'string' ? props.value : props.value.join('-'));
	}, [props.value]);

	return <input type="text" value={inputValue} 
		className={props.className}
		onChange={(event) => {
			if (props.onChange) {
				let value = event.target.value.split('-');

				props.onChange({
					target: {
						value: value
					}
				});
			}
		}}
		onKeyDown={(event) => {
			if (event.key == 'Enter') {
				if (props.onEnter && event.target.value.match(new RegExp('^[0-9]{4}(\-[0-9]{4})?$'))) {
					let value = event.target.value.split('-');

					props.onEnter({
						target: {
							value: value
						}
					});
				}
			}
		}} 
	/>
}

export {
	Container,
	MainHeading,
	SubHeading,
	DocumentSection,
	LinkList,
	Text,
	HtmlContent,
	Table,
	DocumentThumbnailList,
	DocumentThumbnailLink,
	DocumentListItem,
	ItemList,
	ListItem,
	LoadingBar,
	ForeignLabel,
	FilterHelp,
	RangeInput
}